import { defineStore } from "#q-app";
import { createPinia } from "pinia";
import type { Router } from "vue-router";
import type { APIInstance } from "@/boot/api.types";
import type { LoadingBar } from "quasar";
import type { Notifier } from "@/boot/notify";
import type { parseData } from "@/boot/api";
import type { AppConfig } from "@/models/appConfig";
import type { executeRecaptchaAction } from "@/boot/recaptcha";

/*
 * When adding new properties to stores, you should also
 * extend the `PiniaCustomProperties` interface.
 * @see https://pinia.vuejs.org/core-concepts/plugins.html#typing-new-store-properties
 */
declare module "pinia" {
    export interface PiniaCustomProperties {
        // add your custom properties here, if any
        $api: APIInstance;
        $deviceType: AppConfig["device"]["type"];
        readonly router: Router;
        $parseResponse: typeof parseData;
        $loadingBar: LoadingBar;
        $notify: Notifier;
        $executeRecaptchaAction: typeof executeRecaptchaAction;
    }
}

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Store instance.
 */

export default defineStore((/* { ssrContext } */) => {
    const pinia = createPinia();

    // You can add Pinia plugins here
    // pinia.use(SomePiniaPlugin)

    return pinia;
});
